import axios from 'axios';

export const getCountryFromIP = async () => {
  try {
    const response = await axios.get('https://ipapi.co/json/');
    return response.data.country_code;
  } catch (error) {
    console.error('Error fetching country:', error);
    return null;
  }
};

